module.exports = __webpack_public_path__ + "static/img/business11.bbccaa7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/business/business11.png
// module id = yMoJ
// module chunks = 9